const parseActionEnvelopeObject = (payloadObject) => {
  if (!payloadObject || typeof payloadObject !== 'object' || Array.isArray(payloadObject)) return null
  const entries = Object.entries(payloadObject)
  if (entries.length < 1) return null
  const [appEventName, payload] = entries[0]
  if (!appEventName || typeof appEventName !== 'string') return null
  return { appEventName, payload: payload ?? {} }
}

/**
 * JSON action payloads (e.g. allParticipants where the DOM still carries JSON) are forwarded
 * as-is. Opaque token strings from private renders are unchanged.
 */
export const markClientActionPayload = (rawPayload) => {
  if (typeof rawPayload !== 'string') return rawPayload

  const trimmed = rawPayload.trim()
  if (!trimmed.startsWith('{')) return rawPayload

  try {
    const parsedEnvelope = parseActionEnvelopeObject(JSON.parse(trimmed))
    if (!parsedEnvelope) return rawPayload
    return JSON.stringify({
      [parsedEnvelope.appEventName]: parsedEnvelope.payload ?? {}
    })
  } catch (_e) {
    return rawPayload
  }
}

/**
 * @param {string} formAction AppM event name from anear-form action
 * @param {object} values Serialized field values
 * @param {string|null} formToken Optional opaque token from data-form-token (render-time registration)
 */
export const buildFormActionMessage = (formAction, values, formToken = null) => {
  if (!formAction || typeof formAction !== 'string') return JSON.stringify({})

  if (formToken && typeof formToken === 'string') {
    return JSON.stringify({
      [formAction]: {
        key: formToken,
        form_data: values || {}
      }
    })
  }

  return JSON.stringify({
    [formAction]: {
      ...(values || {})
    }
  })
}
